import { render, staticRenderFns } from "./myTest.vue?vue&type=template&id=133821b7"
import script from "./myTest.vue?vue&type=script&lang=js"
export * from "./myTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports